import styled, { css } from "styled-components";
import { greyColor } from "./colors";
import { mobileQuery } from "./MediaQuery";

const baseStyles = css`
  margin: 0;
  white-space: pre-wrap;
  font-family: "Work Sans", sans-serif;
`;

export const Header2 = styled.h2<{ color?: string; center?: boolean }>`
  ${baseStyles};
  font-size: 64px;
  color: ${(props) => props.color ?? greyColor};

  ${(props) => props.center && "text-align: center"};

  ${mobileQuery`
    font-size: 24px;
  `}
`;

export const Header3 = styled.h3<{ color?: string; center?: boolean }>`
  ${baseStyles};
  font-size: 56px;
  color: ${(props) => props.color ?? greyColor};

  ${(props) => props.center && "text-align: center"};

  ${mobileQuery`
    font-size: 24px;
  `}
`;

export const Header4 = styled.h4<{ color?: string; center?: boolean }>`
  ${baseStyles};
  font-size: 24px;
  font-weight: 400;
  color: ${(props) => props.color ?? greyColor};

  ${(props) => props.center && "text-align: center"};

  ${mobileQuery`
    font-size: 16px;
    font-weight: 700;
  `}
`;

export const Header6 = styled.h6<{ color?: string }>`
  ${baseStyles};
  font-size: 21px;
  font-weight: 500;
  color: ${(props) => props.color ?? greyColor};
`;

export const Paragraph1 = styled.p<{ color?: string; center?: boolean }>`
  ${baseStyles};
  line-height: 1.3;
  font-size: 16px;
  color: ${(props) => props.color ?? greyColor};

  ${(props) => props.center && "text-align: center"};

  font-weight: 400;
  ${mobileQuery`
    font-weight: 500;
  `}
`;
